import React, {ReactNode} from 'react'

// Types ----

type ElasticScaleInOutProps = {
  enabled: boolean
  children: ReactNode
}

// Component ----

function ElasticScaleInOut({enabled, children}: ElasticScaleInOutProps) {
  return (
    <div
      className={`${enabled ? "scale-100" : "scale-0"} transition-all duration-400`}
      style={{
        transitionTimingFunction: enabled ? 'cubic-bezier(0, 0.7, 0.4, 1.7)' : 'ease-out',
      }}
    >
      {children}
    </div>
  );
}

export {ElasticScaleInOut};